<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">فاکتورهای کالا</h2>
            <p class="text-sm text-purple-50">مدیریت و مشاهده فاکتورهای درخواست</p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="list.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">فاکتوری یافت نشد</p>
      </div>

      <!-- Factors List -->
      <div v-else class="space-y-4">
        <div 
          v-for="item in list" 
          :key="item.Id"
          @click="goToDetail(item)"
          class="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
        >
          <!-- Factor Header -->
          <div class="mb-4 pb-4 border-b border-gray-200">
            <h3 class="text-md font-bold text-gray-900 mb-2">{{ item.BranchName }}</h3>
            <p class="text-sm text-gray-600">
              <span class="font-medium text-gray-700">{{ item.Summary }}</span>
            </p>
          </div>

          <!-- Status Badge -->
          <div class="flex items-center justify-between">
            <div class="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full">
              {{ item.StatusName }}
            </div>
          </div>
        </div>
      </div>

      <!-- Add New Button -->
      <button 
        @click="goToDetail()"
        class="w-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
      >
        {{ $t('addNewRequest') }}
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
      </button>

    </div>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        list: [],
        errors: [],
        selected_post: 0,
        selected_branch: 0,
        // request_items: [],
        // last_request_items: [],
        show_loading: false,
        no_info: true,
        page: 0,

        first: true,
      }
    },
    components: {
      InfiniteLoading,
    },
    watch: {

    },
    mounted () {
      this.get_factors()
      this.selected_post = parseInt(localStorage.getItem('selected_post'))
    },

    methods: {
      goToDetail (item) {
        if (item != null) {
          this.$router.push({ name: 'RequestGoodsItems', params: { rec_id: item.Id, cost_id:this.$route.params.rec_id } })
        } else {
          this.$router.push({ name: 'RequestGoodsItems', params: { rec_id: 0, cost_id:this.$route.params.rec_id } })
        }
      },
      get_factors () {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          CostCenterId: this.$route.params.rec_id,
        }

        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetGoodsReqByReqId', send_data, {})
          .then(response => {
            self.last_request_items = []
            if (response.data.error == 0) {
             self.list = response.data.items
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style scoped>
  /* Component-specific styles if needed */
</style>
